import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Cookie, ArrowLeft } from 'lucide-react';

export default function CookiesPage() {
  return (
    <div className="container py-8 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <Button variant="ghost" size="icon" asChild>
            <Link to="/">
              <ArrowLeft className="h-5 w-5" />
            </Link>
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Cookie Policy</h1>
            <p className="text-muted-foreground">Last updated: March 1, 2025</p>
          </div>
        </div>

        <Card className="mb-8">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Cookie className="h-5 w-5 text-primary" />
              <CardTitle>How We Use Cookies</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose dark:prose-invert max-w-none">
            <p>
              This Cookie Policy explains how NewLoop uses cookies and similar technologies to recognize
              you when you visit our platform.
            </p>

            <h2>What are Cookies?</h2>
            <p>
              Cookies are small data files placed on your device when you visit a website. They serve
              various purposes, including:
            </p>
            <ul>
              <li>Remembering your preferences</li>
              <li>Understanding how you use our platform</li>
              <li>Improving your experience</li>
              <li>Providing personalized content</li>
            </ul>

            <h2>Types of Cookies We Use</h2>
            
            <h3>Essential Cookies</h3>
            <p>
              Required for the platform to function. They enable basic features like page navigation
              and access to secure areas.
            </p>

            <h3>Functional Cookies</h3>
            <p>
              Help us remember your preferences and customize your experience. They may store your
              language preference or location.
            </p>

            <h3>Analytics Cookies</h3>
            <p>
              Allow us to analyze how visitors use our platform, helping us improve its performance
              and functionality.
            </p>

            <h3>Marketing Cookies</h3>
            <p>
              Used to track visitors across websites to display relevant advertisements and measure
              their effectiveness.
            </p>

            <h2>Cookie Management</h2>
            <p>You can control cookies through your browser settings:</p>
            <ul>
              <li>Block all cookies</li>
              <li>Delete existing cookies</li>
              <li>Allow only certain types of cookies</li>
              <li>Set preferences for specific websites</li>
            </ul>

            <h2>Third-Party Cookies</h2>
            <p>
              Some cookies are placed by third-party services that appear on our pages. We do not
              control these cookies.
            </p>

            <h2>Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy to reflect changes in our practices or for other
              operational, legal, or regulatory reasons.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have questions about our Cookie Policy, please contact us at{' '}
              <a href="mailto:privacy@newloop.dev">privacy@newloop.dev</a>.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}